/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import { useIdleTimeout } from './hooks/useIdleTimeout'
import Layout from './components/Layout'

import './styles/main.css'
import '@az/starc-ui/themes/starc.css'

const App = () => {
  useIdleTimeout()

  return (
    <div className="App">
      <I18nextProvider i18n={i18next}>
        <main>
          <Layout />
        </main>
      </I18nextProvider>
    </div>
  )
}

export default App
